<template lang="pug">
  div.sc-social-card
    div.sc-social-card__header
      div.sc-social-card__header-left
        div.sc-social-card__photo
          img(:src="data.userPicture")
      div.sc-social-card__header-right
        div.sc-social-card__date {{ data.date }}
          span.sc-social-card__type {{ data.type }}
        div.sc-social-card__name {{ data.userName }}
    div.sc-social-card__body
      div.sc-social-card__img(v-if="data.picture")
        img(:src="data.picture")
      div.sc-social-card__description(v-html='description') {{ checkLinks(data.comment) }}
      div.sc-social-card__hashtag {{ data.hashtag || '' }}
</template>

<script>

export default {
  name: 'SocialCard',
  data () {
    return {
      description: null
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkLinks (text) {
      var expression = /[-a-zA-Z0-9@:%_.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_.~#?&//=]*)?/gi
      // ORIGINAL var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
      var regex = new RegExp(expression)
      var t = text
      var enlace = t.match(regex)
      this.description = t.replace(enlace, '<a target="_blank" class="sc-social-card__link" href="' + enlace + '">' + enlace + '</a>')
      return this.description
    }
  }
}
</script>

<style scoped lang="scss">

.sc-social-card{
  padding: rem(16) 0;
  border-bottom: 1px solid $--color-grey-light;

  &:first-child{
    padding-top: 0;
  }

  &:last-child{
    border-bottom: none;
  }
  &__header{
    display: flex;
    &-right{
      margin-left: rem(16);
    }
  }

  &__photo{
    border-radius: 100%;
    height: rem(30);
    overflow: hidden;
    width: rem(30);

    img{
      max-width: 100%;
      height: auto;
    }
  }

  &__date{
    color: $--color--grey-medium;
    font-size: rem(9);
    font-weight: 500;
    line-height: rem(16);
    text-transform: uppercase;
  }

  &__type{
    &:before{
      content: '-';
      margin: 0 rem(4);
    }
  }

  &__name{
    color: $--color-grey-dark;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: 0.17px;
    line-height: rem(18);
  }

  &__img{
    max-width: rem(288);
    margin-top: rem(12);
    img{
      max-width: 100%;
      height: auto;
    }
  }

  &__description{
    margin-top: rem(12);
    color: $--color--grey-medium;
    font-size: rem(12);
    line-height: rem(24);
    max-width: 545px;
  }

  &__hashtag{
    color: $--color-grey-dark;
    font-size: rem(12);
    letter-spacing: 0.17px;
    line-height: rem(18);
  }

  /deep/ &__link{
    color: $--color-primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SocialCard.vue